import { VehicleContext } from "context/vehicleContext";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { addParamToVehicleUrl } from "utils/commonUtils";

const InfiniteScrollSRP = ({
    children,
}: any) => {
    const router = useRouter();
    const {paramsFromUrl, setLoadingVehicles} = useContext(VehicleContext);
    const page = paramsFromUrl?.page ?? 1;

    const getMoreVehicles = () => {
        router.push(addParamToVehicleUrl("page", String(Number(page) + 1)));
    };
  
    useEffect(() => {
        function handleScroll(){
            if(Number(window.scrollY) >= Number(document.body.clientHeight) - Number(window.innerHeight) - 160){
                setLoadingVehicles(true);
                getMoreVehicles();
            }
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {children}
        </>
    );
};

export default InfiniteScrollSRP;
